<template>
  <router-view>
    <div style="display: none">
      {{notice}}
    </div>
  </router-view>
</template>

<script>
  export default {
    name: 'app',
    computed: {
      notice: {
        get () {
          return this.$store.getters.notice
        }
      }
    },
    watch: {
      notice () {
        this.$notify({
          title: this.notice.title,
          message: this.notice.message,
          type: this.notice.type
        })
      }
    }
  }
</script>

<style>
  .el-select-dropdown__item.selected {
    background-color: #081633;
  }
  .el-select-dropdown__item.selected.hover {
    background-color: #081633;
  }
  body {
    margin: 0;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
  }
  .v-modal {
    z-index: -1 !important;
  }
  a {
    font-weight: 100;
    text-decoration:none;
  }
  @media (max-width: 576px) {
    body {
      font-size: 8px;
    }
  }
  @media (min-width: 576px) and (max-width: 768px) {
    body {
      font-size: 9px;
    }
  }
  @media (min-width: 768px) and (max-width: 992px) {
    body {
      font-size: 10px;
    }
  }
  @media (min-width: 992px) and (max-width: 1200px) {
    body {
      font-size: 12px;
    }
  }
  @media (min-width: 1200px) and (max-width: 1500px) {
    body {
      font-size: 14px;
    }
  }
  @media (min-width: 1500px) and (max-width: 2000px) {
    body {
      font-size: 16px;
    }
  }
  @media (min-width: 2000px) {
    body {
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?40080f98